<!--<link rel="stylesheet" href="/assets/quill.core.css" type="text/css" media="all">-->
<!--<link rel="stylesheet" href="/assets/quill.snow.css" type="text/css" media="all">-->
<link rel="stylesheet" href="/assets/quill.custom.css" type="text/css" media="all">
<span [innerHTML]="styles ? (styles | safeHtml) : ''"></span>
<div class="cms-content" [ngStyle]="{'display': inlineBlock ? 'inline-block' : 'block'}" [innerHTML]="content | safeHtml"></div>
